module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#twitter",
      toString: function () {
        return this.url;
      }
    }